import React from "react";
import { Badge, IconButton, Popover } from "@mui/material";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useSriSyncNotifications, SriSyncNotificationI } from "../../../apis";
import "../../css/sri-sync-bell.css";

interface SriSyncNotificationBellProps {
  clientId: string;
  branchId: string | null;
  role: string;
  /** Opcional — se llama al hacer click en una notificación (ej. navegar al panel de Tareas SRI). */
  onClickNotificacion?: (n: SriSyncNotificationI) => void;
}

const formatearHora = (iso: string) =>
  new Date(iso).toLocaleTimeString("es-EC", { hour: "2-digit", minute: "2-digit" });

export const SriSyncNotificationBell: React.FC<SriSyncNotificationBellProps> = ({
  clientId,
  branchId,
  role,
  onClickNotificacion,
}) => {
  const { notificaciones, noLeidas, marcarTodasLeidas, marcarLeida, formatearMensaje } =
    useSriSyncNotifications({ clientId, branchId, role });

  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const abierto = Boolean(anchorEl);

  return (
    <>
      <IconButton
        className="sjn-trigger"
        color="inherit"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        size="small"
      >
        <Badge badgeContent={noLeidas} color="error" max={9}>
          <NotificationsOutlinedIcon style={{ fontSize: 20 }} />
        </Badge>
      </IconButton>

      <Popover
        open={abierto}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <div className="sjn-panel">
          <div className="sjn-panel-header">
            <span>Notificaciones SRI</span>
            {noLeidas > 0 && <button onClick={marcarTodasLeidas}>Marcar todo como leído</button>}
          </div>

          {notificaciones.length === 0 ? (
            <div className="sjn-empty">Todavía no hay notificaciones</div>
          ) : (
            notificaciones.map((n:any) => (
              <div
                key={`${n.jobId}-${n.timestamp}`}
                className={`sjn-item ${n.leida ? "" : "no-leida"}`}
                onClick={() => {
                  marcarLeida(n.jobId);
                  onClickNotificacion?.(n);
                  setAnchorEl(null);
                }}
              >
                <div className={`sjn-item-icon ${n.status === "COMPLETED" ? "ok" : "error"}`}>
                  {n.status === "COMPLETED" ? (
                    <CheckCircleOutlineIcon style={{ fontSize: 16 }} />
                  ) : (
                    <HighlightOffIcon style={{ fontSize: 16 }} />
                  )}
                </div>
                <div className="sjn-item-body">
                  <div className="sjn-item-msg">{formatearMensaje(n)}</div>
                  <div className="sjn-item-time">{formatearHora(n.timestamp)}</div>
                </div>
                {!n.leida && <div className="sjn-dot" />}
              </div>
            ))
          )}
        </div>
      </Popover>
    </>
  );
};

export default SriSyncNotificationBell;